<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/htgl2.png" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/htgl1.png" class="steps step2" v-if="status==2">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'新建线下合同'}]"/>
        <div class="h-content" :class="{'ljjtips':true}">
            <div class="h-piece">
                <div class="outerCon">
                    <div class="tabBtn" :class="{tabBtnAc:tabIndex == '1'}" @click="tabchange(1)">合同</div>
                    <div class="tabBtn" :class="{tabBtnAc:tabIndex == '3'}" @click="tabchange(3)">目标</div>
                    <div class="tabBtn" :class="{tabBtnAc:tabIndex == '2'}" @click="tabchange(2)">目标对阵</div>
                </div>
                <div class="h-formLine weekplandetail23" v-show="tabIndex == '1'">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                        <h1>合同详情</h1>
                    </div>
                    <el-form label-position="right" :model="formInline" ref="form1" :rules="rules" label-width="120px"
                             class="h-form">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="合同编码" prop="Id">
                                    <el-input v-model.number="formInline.id" :disabled="disabled"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="合同名称" prop="contractName">
                                    <el-select v-model="formInline.contractName" style="width: 100%" placeholder="请选择"
                                               @change="changeDlsType">
                                        <el-option value="国内市场经销合同">国内市场经销合同</el-option>
                                        <el-option value="国内市场经销合同-血液">国内市场经销合同-血液</el-option>
                                        <el-option value="平台商合同">平台商合同</el-option>
                                        <el-option value="康盛合同">康盛合同</el-option>
                                        <el-option value="鸿鹄合同">鸿鹄合同</el-option>
                                        <el-option value="海盛杰合同">海盛杰合同</el-option>
                                        <el-option value="厚宏合同">厚宏合同</el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="经销商合同类型" prop="contractAgent">
                                    <brselect category="contract_agent" @input="changeCatogory"
                                              :v="formInline.contractAgent"
                                              v-model="formInline.contractAgent" :disabled="disabled"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="对阵一级经销商" prop="oneLevelAgentName"
                                              v-if="(formInline.contractAgent==8 || formInline.contractAgent == 2) &&  tabIndex=='1'">
                                    <el-select v-model="formInline.oneLevelAgentName"
                                               :title="formInline.oneLevelAgentName"
                                               remote filterable :filter-method="showAgentList" clearable
                                               placeholder="请输入"
                                               :remote-method="showAgentList" @change="changeAgent($event)">
                                        <el-option v-for="(item) in oneAgentList"
                                                   :key="item.customerName"
                                                   :label="item.customerName"
                                                   :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="客户名称" prop="customerCode">
                                    <el-input v-model="formInline.customerName" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="销售渠道" prop="salechannelCode">
                                    <brselect :multiple="true" category="sales_region"
                                              :v="formInline.salechannelCode"
                                              :disabled="disabled"
                                              v-model="formInline.salechannelCode"
                                              :clearable="true"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="销售省份" prop="saleareaCode">
                                    <brselect category="YlSalesArea_chanpin" :v="formInline.saleareaCode"
                                              @change="changeArea($event)"
                                              v-model="formInline.saleareaCode" :disabled="disabled"></brselect>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div v-for="(listIt, index) in formInline.salesCityList" :key="index" class="h-formBox">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="销售地市" prop="salesCityName">
                                        <el-input v-model="formInline.salesCityList[index].salesCityName"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="业务人员" prop="yewuname">
                                        <el-input v-model="formInline.salesCityList[index].yewuname"
                                                  placeholder="请输入数字"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="联系方式" prop="phone">
                                        <el-input v-model="formInline.salesCityList[index].phone" placeholder="请输入数字"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="合同金额(元)" prop="contractAmount">
                                    <el-input v-model.number="formInline.contractAmount" :disabled="disabled"
                                              placeholder="请输入数字">
                                        <i slot="prefix" style="font-style: normal; font-weight: bold;">￥</i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="合同开始时间" prop="contractStarttime">
                                    <el-date-picker :clearable="false" type="date" placeholder="选择时间"
                                                    v-model="formInline.contractStarttime"
                                                    :picker-options="pickerOptions1" @change="setZlDate()"
                                                    :disabled="disabled"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="合同结束时间" prop="contractEndtime">
                                    <el-date-picker :clearable="false" type="date" placeholder="选择时间"
                                                    v-model="formInline.contractEndtime"
                                                    :picker-options="pickerOptions2"
                                                    :disabled="disabled"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="用户个数(传统)" prop="userNum" v-if="isCt">
                                    <el-input v-model.number="formInline.userNum" :disabled="disabled"
                                              placeholder="请输入数字"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form label-position="right" :model="file" :rules="rules" label-width="120px"
                                 class="h-form">
                            <el-row :gutter="20">
                                <el-col :span="20">
                                    <el-form-item label="主合同文件" prop="name">
                                        <brupload :refid="this.contractId" reftype="合同附件" :uploadflag="fileFlag"
                                                  :delflag="fileFlag"
                                                  :tpFlag='true' :isTpAndPdf='true'
                                        ></brupload>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="20">
                                    <el-form-item label="合同工程专业承包资质" v-if="isKa" prop="name">
                                        <brupload :refid="this.contractId" reftype="合同工程专业承包资质" :uploadflag="fileFlag"
                                                  :delflag="fileFlag"
                                                  :tpFlag='true' :isTpAndPdf='true'
                                        ></brupload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                            <h1>产业合同</h1>
                        </div>
                        <el-form label-position="right" :model="formInline" ref="form2" :rules="rules"
                                 label-width="80px"
                                 class="h-form">
                            <div v-for="(listIt, index) in formInline.industryList" :key="index" class="h-formBox">
                                <el-row :gutter="24">
                                    <el-col :span="5">
                                        <el-form-item label="产业" prop="industry">
                                            <brselect category="swyl_industry"
                                                      :v="formInline.industryList[index].industry"
                                                      :disabled="disabled"
                                                      v-model="formInline.industryList[index].industry"
                                                      :clearable="true"
                                            />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="销售区域" class="hsalesCity" prop="saleareaCode"
                                                      v-if="listIt.industry">
                                            <brselect category="YlSalesArea_chanpin"
                                                      :v="formInline.industryList[index].saleareaCode"
                                                      v-model="formInline.industryList[index].saleareaCode"
                                                      :disabled="disabled"></brselect>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="销售地市" class="hsalesCity" prop="salesCity"
                                                      :prop="`industryList[${index}].salesCityName`">
                                            <el-input v-model="formInline.industryList[index].salesCityName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="销售渠道" class="hsalesCity" prop="channel"
                                                      v-if="listIt.industry">
                                            <brselect :multiple="true" category="sales_region"
                                                      :v="formInline.industryList[index].channel"
                                                      :disabled="disabled"
                                                      v-model="formInline.industryList[index].channel"
                                            />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="用户个数" class="hsalesCity" prop="userNum"
                                                      v-if="listIt.industry">
                                            <el-input v-model.number="formInline.industryList[index].userNum"
                                                      :disabled="disabled"
                                                      placeholder="请输入数字"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="合同金额" prop="contractAmount" v-if="listIt.industry">
                                            <el-input v-model.number="formInline.industryList[index].contractAmount"
                                                      :disabled="disabled && update!=2"
                                                      placeholder="请输入数字"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-form-item label="附件" style="width: 100%;" prop="id" v-if="listIt.industry">
                                            <brupload :refid="contractId+formInline.industryList[index].industry"
                                                      reftype="合同附件" :uploadflag="!disabled"
                                                      :delflag="!disabled"
                                                      :tpFlag='true' :isTpAndPdf='true'
                                            ></brupload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-form>
                        <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;"
                             v-if="this.formInline.pid != null && this.formInline.pid != '' || this.formInline.pass == 2">
                            <h1>销售目标及目标对阵用户详情</h1>
                        </div>
                        <el-form label-position="right" :model="file" :rules="rules" :inline="true"
                                 label-width="120px" class="h-form"
                                 v-if="formInline.pid != null && formInline.pid != '' || formInline.pass == 2">
                            <el-row :gutter="20">
                                <el-col :span="20">
                                    <el-form-item label="子合同文件" prop="name">
                                        <brupload :refid="contractId" reftype="销售目标及目标对阵用户详情" :uploadflag="fileFlag"
                                                  :delflag="fileFlag"
                                                  :tpFlag='true' :isTpAndPdf='true'
                                        ></brupload>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                        </el-form>


                        <el-form-item label="合同工程专业承包资质" v-if="isKa" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2"
                                      style="width: 100%;" prop="name">
                            <brupload :refid="this.contractId" reftype="合同工程专业承包资质" :uploadflag="fileFlag"
                                      :delflag="fileFlag"
                                      :tpFlag='true' :isTpAndPdf='true'
                            ></brupload>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;"
                     v-if="this.formInline.pid != null && this.formInline.pid != '' || this.formInline.pass == 1 || isFb">
                    <h1>销售目标及目标对阵用户详情</h1>
                </div>
                <el-form label-position="right" :model="file" :rules="rules" :inline="true"
                         class="demo-ruleForm h-formbLine"
                         v-if="this.formInline.pid != null && this.formInline.pid != '' || this.formInline.pass == 1">
                    <el-form-item label="子合同文件" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;"
                                  prop="name">
                        <brupload :refid="this.contractId" reftype="销售目标及目标对阵用户详情" :uploadflag="false" :delflag="false"
                                  :tpFlag='true' :isTpAndPdf='true'
                        ></brupload>
                    </el-form-item>
                </el-form>

                <el-form label-position="right" :model="file" :rules="rules" :inline="true"
                         class="demo-ruleForm h-formbLine" v-if="isFb">
                    <el-form-item label="附表上传" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;"
                                  prop="name">
                        <brupload :refid="this.contractId" reftype="销售目标及目标对阵用户详情" :uploadflag="isFb"
                                  :delflag="isFb"
                                  :tpFlag='true' :isTpAndPdfNotSize='true'
                        ></brupload>
                    </el-form-item>
                </el-form>
                <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;" v-if="!isFb">
                    <h1>合同</h1>
                </div>
                <li v-for="o,i in this.contractSonList" :tabindex="i" :key="o.id"
                    class="el-upload-list__item is-success">
                    <a class="el-upload-list__item-name" @click="checkSon(o.id)" v-down="o.id"><i
                            style="margin-left: 50px"></i>{{o.id}}
                    </a>
                </li>
                <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;margin-top: 0.3rem" v-if="isfxzb">
                    <h1>分销商指标数</h1>
                </div>
                <div class="h-table h-mrt30" v-if="isfxzb">
                    <el-table
                            ref="multipleTable"
                            :data="contractAgentAddFxList"
                            stripe
                            style="width: 100%"
                            :border="true"
                            max-height="450"
                    >
                        <el-table-column
                                type="selection"
                                width="40"
                                label="全选"
                        >
                        </el-table-column>
                        <el-table-column
                                fixed
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="agentName"
                                label="经销商名称"
                                :show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="agentCode"
                                label="经销商编码"
                                :show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="channel"
                                label="渠道"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="rebateChainGroup"
                                label="链群"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="year"
                                label="年"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="janL"
                                label="1月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="febL"
                                label="2月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="marL"
                                label="3月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="aprL"
                                label="4月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="mayL"
                                label="5月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="junL"
                                label="6月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="julL"
                                label="7月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="augL"
                                label="8月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="sepL"
                                label="9月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="octL"
                                label="10月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="novL"
                                label="11月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="deceL"
                                label="12月"
                                min-width="100"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                    </el-table>
                </div>


                <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;margin-top: 0.3rem" v-if="!isFb">
                    <h1>补充协议</h1>
                </div>
                <div class="signsign" v-if="!isFb">
                    <div class="h-formLine" style="margin-top:0.38rem">
                        <el-form :model="contarctAdd" label-position="right"
                                 ref="formLabelAlign11" label-width="100px"
                                 class="h-form">
                            <div v-for="(listIt, index) in contarctAddList" :key="index">
                              <el-row :gutter="20">
                                <el-col :span="5">
                                  <el-form-item label="类别" prop="type">
                                    <el-select v-model="contarctAddList[index].type" placeholder="请选择"
                                               @change="changeContractAdd($event)" :disabled="!isXy">
                                      <el-option label="分销商上平台补充协议" value="1"></el-option>
                                      <el-option label="阶段性奖励" value="2"></el-option>
                                    </el-select>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                  <el-form-item label="开始时间" prop="starttime">
                                    <el-date-picker :clearable="false" type="date" placeholder="选择时间" :disabled="!isXy"
                                                    v-model="contarctAddList[index].starttime"
                                                    :picker-options="pickerOptions1"></el-date-picker>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                  <el-form-item label="结束时间" prop="endtime">
                                    <el-date-picker :clearable="false" type="date" placeholder="选择时间" :disabled="!isXy"
                                                    v-model="contarctAddList[index].endtime"
                                                    :picker-options="pickerOptions2"></el-date-picker>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                  <el-form-item label="附件" required prop="name">
                                    <brupload :refid="contarctAddList[index].refid" reftype="合同-补充协议" :uploadflag="isXy"
                                              :showtime="false" :delflag="isXy"></brupload>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="4" v-if="index == 0 && isXy">
                                  <el-button-group>
                                    <el-button type="primary" size="mini" @click="addXyList(index)" title="新增">＋
                                    </el-button>
                                    <el-button type="primary" size="mini" title="删除" @click="deleteXyList">－</el-button>
                                  </el-button-group>
                                </el-col>

                              </el-row>
                            </div>
                        </el-form>
                    </div>
                </div>

                <div class="h-txtCenter h-mrt60" v-if="disabled">

                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitAgentAdd" v-if="isXy">确认提交</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="fbSubmit('0')" v-if="isFb">确认提交</el-button>

                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                </div>
            </div>
            <el-table
                    ref="multipleTable"
                    v-show="tabIndex == '2'"
                    :data="tableData2"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        fixed
                        width="50">
                </el-table-column>
                <el-table-column prop="year" label="年份" width="60px"></el-table-column>
                <el-table-column prop="province" label="省份" width="90px"></el-table-column>
                <el-table-column prop="city" label="地市" width="90px"></el-table-column>
                <el-table-column prop="scenesName" label="渠道" width="90px"></el-table-column>
                <el-table-column prop="agentName" label="经销商" width="150px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <!-- <el-table-column prop="contractId" label="经销商合同" width="120px"></el-table-column> -->
                <el-table-column prop="customerName" label="用户名称" width="180px" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{scope.row.customerName}}
                    </template>
                </el-table-column>
                <el-table-column prop="incomeTarget" label="预计目标收入(万元)" width="100px"></el-table-column>
                <el-table-column prop="distributorUsers" label="分销商3.0" width="150px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="facingyewuyuan" label="对阵业务员" width="100px"></el-table-column>
                <el-table-column prop="isTop" label="是否TOP" width="100px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isTop == 0">否</span> <span v-if="scope.row.isTop == 1">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="子场景" width="110px" :show-overflow-tooltip="true"></el-table-column>

                <el-table-column prop="status" label="状态" width="120px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.delflag == 1">
                            <span v-if="scope.row.status == 1 && scope.row.delflag == 1">正常</span>
                            <span v-if="scope.row.status == 2 && scope.row.delflag == 1">审核中</span>
                            <span v-if="scope.row.status == 3 && scope.row.delflag == 1">作废</span>
                            <span v-if="scope.row.status == 0 && scope.row.delflag == 1">已删除</span>
                        </div>
                        <div v-if="scope.row.delflag == 0">
                            <span v-if="scope.row.delflag == 0">已删除</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="agentLevel" label="经销商类型" width="110px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.agentLevel == 1">一级经销商</span>
                        <!-- <span v-if="scope.row.agentLevel == 2">分销商</span> -->
                        <span v-if="scope.row.agentLevel == 3">专营商</span>
                        <!-- <span v-if="scope.row.agentLevel == 4">直单用户</span>
                        <span v-if="scope.row.agentLevel == 5">分销商3.0</span> -->
                        <span v-if="scope.row.agentLevel == 6">地市直营商</span>
                    </template>
                </el-table-column>
                <el-table-column prop="againstMode" label="对阵模式" width="150px">
                    <template slot-scope="scope">
                        {{scope.row.againstMode|dictname('against_mode')}}
                    </template>
                </el-table-column>
                <el-table-column prop="facingReseller" label="对阵分销商1.0" width="100px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="cuname" label="创建人" width="100px"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="cdate" label="创建时间" width="140px"></el-table-column>
            </el-table>

            <div class="h-tableB h-mrt30" v-if="tabIndex == '2'">
                <div class="h-tableBL">
                    <!--  <div class="h-tableBL">
                          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcelAll">批量导出
                          </el-button>
                          <uploaddownexcel
                                  :visible.sync="uploaddownexcelflag"
                                  v-if="uploaddownexcelflag"
                                  clsname="bscTargetAgainstUserExcel"
                                  :startrow="2" @callback="uploadExcelFilecallback"/>
                      </div>-->
                </div>
                <div class="h-pagination2">
                    <pagination :page="q2" @query="selectPageAll"/>
                </div>
            </div>

            <el-table
                    ref="ddtable"
                    v-show="tabIndex == '3'"
                    :data="tableData3"
                    stripe
                    style="width: 100%"
                    :border="true"
                    max-height="520"
            >
                <el-table-column
                        type="index"
                        label="#"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="year"
                        label="年"
                        :show-overflow-tooltip="true"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="area"
                        label="区域"
                        :show-overflow-tooltip="true"
                        width="60">
                </el-table-column>
                <el-table-column
                        prop="agentCode"
                        label="经销商编码"
                        :show-overflow-tooltip="true"
                        fixed
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="agentName"
                        label="经销商名称"
                        :show-overflow-tooltip="true"
                        fixed
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.agentName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="agentType"
                        label="经销商类型"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.agentType|dictname('fl_agent_type')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="salesRegionCode"
                        label="渠道"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.salesRegionCode|dictname('fl_sales_region_qudao')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="rebateChainGroup"
                        label="链群"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template slot-scope="scope">
                        <div v-if="scope.row.rebateChainGroup=='cthj'">传统</div>
                        <div v-if="scope.row.rebateChainGroup!='cthj'">
                            {{scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="qunianTongqi"
                        label="去年同期(万元)"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.qunianTongqi}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="jinnianGoal"
                        label="今年目标(万元)"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.jinnianGoal}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="1月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume1"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume1}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal1"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal1}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="2月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume2"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume2}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal2"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal2}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="3月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume3"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume3}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal3"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal3}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="4月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume4"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume4}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal4"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal4}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="5月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume5"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume5}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal5"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal5}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="6月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume6"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume6}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal6"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal6}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="7月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume7"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume7}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal7"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal7}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="8月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume8"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume8}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal8"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal8}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="9月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume9"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume9}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal9"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal9}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="10月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume10"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume10}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal10"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal10}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="11月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume11"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume11}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal11"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal11}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="12月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="salesVolume12"
                            label="同期(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.salesVolume12}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal12"
                            label="目标(万元)"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.goal12}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column
                        prop="planStatus"
                        label="审批状态"
                        width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.planStatus == 1">平台审批中</div>
                        <div v-if="scope.row.planStatus == 2">审批通过</div>
                        <div v-if="scope.row.planStatus == 3">驳回</div>
                        <div v-if="scope.row.planStatus == 4">省区经理审批中</div>
                        <div v-if="scope.row.planStatus == 5">总监审批中</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="statu"
                        label="有效性"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.statu == 2">有效</div>
                        <div v-if="scope.row.statu == 5">已退出</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30" v-if="tabIndex == '3'">
                <div class="h-tableBL">
                    <!--<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportTargetExcel" v-auth="'fl_goal_pldc'">批量导出
                    </el-button>-->
                </div>
                <div class="h-pagination2">
                    <pagination :page="q3" @query="queryMb"/>
                </div>
            </div>
        </div>


        <div class="bannerBox2" v-if="!this.disabled">
            <div class="h-row h-mrt1">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                                    <h1>审核信息</h1>
                                </div>
                                <div class="h-pieceCon2 ">
                                    <div class="h-formLine weekplandetail11" style="position: relative;">
                                        <el-form :inline="true" :model="formInline">
                                            <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                          style="width: 100%!important;">
                                                <el-input
                                                        v-model="formInline.auditMind2"
                                                        placeholder="请输入"></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="text-align: center;margin-top: 0.3rem" v-if="!this.disabled">
            <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default"
                       v-if="!this.daquflag && !this.lastflag"
                       @click="cancel">返回
            </el-button>
            <el-button class="h-btn h-bBtn h-bgred"
                       @click="daquPass(2)" v-if="this.daquflag && this.formInline.pass != 2">驳回
            </el-button>
            <el-button class="h-btn h-bBtn h-bgred"
                       @click="passFb(2)" v-if="this.daquflag && this.formInline.pass == 2">驳回
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" v-if="this.daquflag && this.formInline.pass != 2"
                       @click="daquPass(1)">通过
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" v-if="this.daquflag && this.formInline.pass == 2"
                       @click="passFb(1)">通过
            </el-button>
            <el-button class="h-btn h-bBtn h-bgred"
                       @click="contractPass(2)" v-if="this.lastflag">驳回
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" v-if="this.lastflag" @click="contractPass(1)">通过
            </el-button>

            <el-button class="h-btn h-bBtn" @click="viewpress">
                审批跟踪
            </el-button>

        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory"
                     :id="instid"/>
    </div>

    </div>
</template>

<script>
    import big from 'big.js';
    import ss from "../../../api/SystemService";
    import util from "../../../utils/util";

    export default {
        name: 'leftMenu',
        data() {
            return {
                // 新手引导页
                toshow: "contract-agent.vue",
                checked: true,
                status: 1,
                showOrhide: false,
                isFb: false,
                contractId: null,
                guanlianxiangmFlag: true,
                isKa: false,
                optionsProduct2_jzx: [],
                optionsProduct2: [],
                optionsProduct1: [],
                lianqunList: [],
                qudao: [],
                customerlabel: "客户名称",
                allProjectByUser: [],
                tempProject: [],
                tempProject2: [],
                tableData2: [],
                tableData3: [],
                contarctAddList: [{
                    id: null,
                    contractId: null,
                    type: null,
                    starttime: null,
                    endtime: null,
                    status: null,
                    instid: null,
                    refid: this.$util.getUuid(),
                }],
                contarctAdd: {
                    id: null,
                    contractId: null,
                    saleareaCode: null,
                    type: null,
                    starttime: null,
                    endtime: null,
                    status: null,
                    instid: null,
                    refid: null,
                    contarctAddLists: [],
                },
                zlflag: false,
                bzflag: false,
                dlsflag: false,
                uploaddownexcelflag: false,
                showhistory: null,
                pickerOptions1: {
                    disabledDate: (time) => {
                        if (this.formInline.contractEndtime != "") {
                            return time.getTime() > this.formInline.contractEndtime;
                        }
                    }
                },
                q2: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    contractId: null,
                    customerName: null
                },
                q3: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    contractId: null,
                    agentNameLike: null,
                },
                viewpress() {
                    this.showhistory = true;
                },
                pickerOptions2: {
                    disabledDate: (time) => {
                        if (this.formInline.contractStarttime != "") {
                            return time.getTime() < this.formInline.contractStarttime;
                        }
                    }
                },
                //表单
                formInline: {
                    zltype: "",
                    contractName: null,
                    pid: "",
                    customerCode: "",
                    salechannelCode: null,
                    contractCatecory: "CT-DLS-KJ",
                    contractAmount: "",
                    contractStatus: "",
                    contractStarttime: "",
                    contractEndtime: "",
                    contractCashPledge: "",
                    productCode: "",
                    productName: "",
                    productPrice: "",
                    productType: "",
                    rentNum: "",
                    rentTime: "",
                    guaranteeTime: "",
                    productList: [],
                    zsyzq: "",
                    rentType: "",
                    isShhm: 0,
                    isJj: 0,
                    rentPlace: "",
                    returnPlace: "",
                    rentPrice: "",
                    contractAgent: "",
                    auditMind2: "",
                    status: "",
                    isZc: "",
                    saleareaCode: null,
                    salesCity: "",
                    salesCityList: [
                        {
                            salesCity: "",
                            yewuname: "",
                            phone: "",
                            salesCityName: ""
                        },
                    ],
                    industryList: [
                        {
                            industry: "",
                            channel: "",
                            userNum: "",
                            saleareaCode: "",
                            salesCity: "",
                            salesCitys: []
                        },
                    ],
                },
                formInline1: {
                    wuliufangshi: 2,
                    condition: []
                },
                fieldList: [
                    {name: '医疗创新领域', code: 'L1'},
                    {name: '生命科学领域', code: 'L2'}
                ],
                customerList: [],
                //多选
                checkList: [],
                fileList: [],
                salesCity: [],
                channels: null,
                isCt: false,
                isfxzb: false,
                file: {
                    name: ''
                },
                rules: {
                    contractName: [
                        {required: true, message: '请输入合同名称', trigger: 'blur'},
                    ],
                    contractCatecory: [
                        {required: true, message: '请选择合同类型', trigger: 'change'},
                    ],
                    contractStarttime: [
                        {required: true, message: '请输入合同开始时间', trigger: 'blur'},
                    ],
                    contractEndtime: [
                        {required: true, message: '请输入合同结束时间', trigger: 'blur'},
                    ],
                },
                jzxFlag: false,
                rentTimeList: [],
                contractSonList: [],
                contractAgentAddFxList: [],
                taskid: null,
                Instid: null,
                isXy: false,
                tabIndex: null,
                disabled: false,
                fileFlag: true,
                daquflag: false,
                lastflag: false,

            }
        },
        methods: {
            save() {
                this.formInline.editStatus = 0;
                var cond = this.formInline1.condition;
                this.formInline.payCondition = cond.join(",");
                this.formInline.contractType = 0;
                this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
                this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
                this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
                if (cate == "CT-ZL" && this.formInline.zltype == '3') {
                    var totalMoney = new big(0);
                    if (this.formInline.zlList) {
                        this.formInline.zlList.forEach((obj) => {
                            totalMoney = totalMoney.plus(new big(obj.productTotalPrice));
                        })
                    }
                    this.formInline.contractAmount = totalMoney;
                }
                this.formInline.zlList = this.formInline.zlList;
                ss.contractService.insertAgent(this.formInline).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("保存成功！");
                        this.$router.push("contract-list");
                    } else {
                        this.$msg.msgs("保存失败！" + rd.msg);
                    }
                });
            },
            submit(rd) {
                var subflag1 = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        subflag1 = true;
                    } else {
                        this.$msg.msge("请完善合同信息后再提交！");
                        return false;
                    }
                });
                if (!subflag1) {
                    return;
                }
                this.$msg.confirm("确定要提交吗？", () => {
                    ss.contractService.insertAgent(this.formInline).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("contract-list");
                        } else {
                            this.$msg.msgs("提交失败！" + rd.msg);
                        }
                    })
                })
            },
            isEmpty(attr) {
                if (attr == null || attr == "") {
                    return true;
                } else {
                    return false;
                }
            },
            isNotEmpty(attr) {
                if (attr != null && attr != "") {
                    return true;
                } else {
                    return false;
                }
            },
            changeCatogory(attr) {

            },
            formatDate(date) {
                if (this.isNotEmpty(date)) {
                    function addDateZero(num) {
                        return (num < 10 ? "0" + num : num);
                    }

                    let d = new Date(date);
                    let format = d.getFullYear() + "-" + addDateZero(d.getMonth() + 1) + "-" + addDateZero(d.getDate());
                    return format;
                }
            },
            daquPass(query) {
                this.formInline.aaa = query;
                ss.contractService.daquPass(this.formInline).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                })
            },
            fbSubmit() {
                this.formInline.salesCity = this.citys;
                this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
                this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
                ss.contractService.insertAgentFb(this.formInline).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("contract-list");
                    } else {
                        this.$msg.msgs("提交失败！" + rd.msg);
                    }
                })
            },
            contractPass(query) {
                this.formInline.aaa = query;
                ss.contractService.contractPass(this.formInline).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                })
            },


            //查询渠道
            selectChannel() {
                ss.Dictservice.listbycategory("sales_region").then(response => {
                    this.qudao = response;
                })
            },
            lianqunOptions(value) {
                console.log("value", value);
                var jsonObj = value
                var jStr = '';
                for (var item in jsonObj) {
                    jStr += jsonObj[item] + ",";
                }
                this.formInline.lianqun = jStr.substring(0, jStr.lastIndexOf(','))
                console.log(this.formInline.lianqun);
            },
            getQudao(value) {
                console.log(value);
                var jsonObj = value
                var jStr = '';
                for (var item in jsonObj) {
                    jStr += jsonObj[item] + ",";
                }
                this.channels = jStr.substring(0, jStr.lastIndexOf(','))
            },
            getLianquns(s) {
                var m = s.split(',');
                if (m.length <= 0) {
                    this.lianqunList = ''
                } else {
                    this.lianqunList = m
                }
                if (this.formInline.lianqun.includes("X02") || this.formInline.lianqun.includes("X01")
                    || this.formInline.lianqun.includes("X08") || this.formInline.lianqun.includes("X09") || this.formInline.lianqun.includes("X10")
                    || this.formInline.lianqun.includes("X05") || this.formInline.lianqun.includes("X06")
                ) {
                    this.isCt = true;
                } else {
                    this.isCt = false;
                }
            },
            // 关闭新手引导页
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            fillCusCode() {
                this.formInline.customerCode = this.formInline.customerName;
            },
            nextStep(i) {
                if (this.status == 1) {
                    this.status = 2;
                } else if (this.status == 2) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            },
            // 时间戳转换日期
            timestampToTime(timestamp) {
                var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let Y = date.getFullYear();
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
                let D = date.getDate().toString().padStart(2, 0);
                let h = date.getHours() + ':';
                let m = date.getMinutes() + ':';
                let s = date.getSeconds();
                return Y + '-' + M + '-' + D;//+h+m+s
            },
            /**
             * 查询当天日期
             */
            // getNowDate(d) {
            //   const timeOne = new Date()
            //   const year = timeOne.getFullYear()
            //   let month = timeOne.getMonth() + 1
            //   let day = timeOne.getDate()
            //   month = month < 10 ? '0' + month : month
            //   day = day < 10 ? '0' + day : day
            //   const NOW_MONTHS_AGO = `${year}-${month}-${day}`
            //   return NOW_MONTHS_AGO
            // },
            stRentTime() {
                let that = this;
                that.formInline.contractStarttime = that.timestampToTime(new Date().getTime());// 默认开始日期
                that.formInline.contractEndtime = that.timestampToTime(new Date().getTime() + that.formInline.rentTime * 24 * 60 * 60 * 1000);// 默认结束日期
                for (var i = 0; i < this.rentTimeList.length; i++) {
                    var priceData = this.rentTimeList[i];
                    if (priceData.rentTerm == this.formInline.rentTime) {
                        that.formInline.rentPrice = priceData.rentPrice;
                        if (this.formInline.zlList) {
                            for (var j = 0; j < this.formInline.zlList.length; j++) {
                                var zl = this.formInline.zlList[j];
                                if (zl.priceType == 'ZL01') {
                                    zl.productUnitPrice = priceData.rentPrice;
                                }
                            }
                        }
                    }
                }
            },
            setZlDate() {
                let that = this;
                var newDate = new Date(that.formInline.contractStarttime);
                that.formInline.contractEndtime = that.timestampToTime(newDate.getTime() + that.formInline.rentTime * 24 * 60 * 60 * 1000 - 24 * 60 * 60 * 1000);// 默认结束日期
            },
            setAddDate(index) {
                let that = this;
                var newDate = new Date(that.contarctAddList[index].starttime);
                that.contarctAddList[index].endtime = that.timestampToTime(newDate.getTime() + that.formInline.rentTime * 24 * 60 * 60 * 1000 - 24 * 60 * 60 * 1000);// 默认结束日期
            },
            cancel() {
                this.$router.push("contract-list");
            },
            getCity(s) {
                var s1 = s;
                var m = s1.split(',');
                if (m.length <= 0) {
                    this.formInline.salesCity = ''
                } else {
                    this.formInline.salesCity = m
                }
            },
            getAreaCity() {
                let areas = this.formInline.saleareaCode.split(",");
                let ss1 = [];
                let promises = []; // 创建一个存储异步操作的Promise数组
                for (var i = 0; i < areas.length; i++) {
                    let promise = ss.Dictservice.getDictByCateCode("YlSalesArea_chanpin", areas[i])
                        .then(response => {
                            ss1.push(response.refid);
                        });
                    promises.push(promise); // 将每个异步操作的Promise添加到数组中
                }

                Promise.all(promises) // 等待所有异步操作完成
                    .then(() => {
                        var s2 = ss1.join(",");
                        ss.UserService.getCityByArea(s2).then(rd => {
                            this.salesCity = rd.msg;
                        });
                    });
            },
            //框架合同table页
            tabchange(i) {
                console.log(i);
                this.tabIndex = i;
                if (this.tabIndex == '1') {
                    this.tabflag = true;
                } else if (this.tabIndex == '3') {
                    this.tabflag = true;
                } else if (this.tabIndex == '2') {
                    this.tabflag = true;
                }
            },
            selectPageAll() {
                this.q2.agentName = this.formInline.customerCode;
                this.q2.contractId = this.formInline.id;
                ss.grabOrderApi.selectPageTargetAgainstUser(this.q2).then(res => {
                    console.log(res)
                    console.log("total", res.total)
                    this.tableData2 = res.records
                    this.q2.total = res.total
                    console.log("table", this.tableData2)
                })
            },
            queryMb() {
                this.q3.agentNameLike = this.formInline.customerName;
                this.q3.contractId = this.formInline.id;
                this.q3.areaCode = this.formInline.saleareaCode;
                this.q3.salesRegionCode = this.formInline.salechannelCode;
                ss.fanli.pagefanliXsjlContractLog(this.q3).then(rd => {
                    this.q3.total = rd.total;
                    this.tableData3 = rd.records;
                });

            },
            getContarctSon(v) {
                ss.contractService.getContractSon(v).then(rd => {
                    this.contractSonList = rd.msg;
                })
            },
            checkSon(id) {
                this.$router.push({path: "/contract-agent-see", query: {key: id}})
            },
            addXyList() {
                this.contarctAddList.push({
                    id: null,
                    contractId: null,
                    type: null,
                    starttime: null,
                    endtime: null,
                    status: null,
                    instid: null,
                    refid: this.$util.getUuid(),
                })
            },
            deleteXyList() {
                if (this.contarctAddList.length != 1) {
                    this.contarctAddList.splice(this.contarctAddList.length - 1, 1)
                }
            },
            changeContractAdd() {
                this.isfxzb = false;
                for (var i = 0; i < this.contarctAddList.length; i++) {
                    if (this.contarctAddList[i].type == 1) {
                        this.isfxzb = true;
                        let contract = {
                            customerCode: this.formInline.customerCode,
                        }
                        ss.contractService.contractAgentAddFxListPage(contract).then(rd => {
                            this.contractAgentAddFxList = rd.msg;
                        });
                        break;
                    }
                }
            },
            submitAgentAdd() {
                this.$msg.confirm("确定要提交吗？", () => {
                    this.contarctAdd.contarctAddLists = this.contarctAddList;
                    this.contarctAdd.contractId = this.formInline.id;
                    this.contarctAdd.saleareaCode = this.formInline.saleareaCode;
                    ss.contractService.insertAgentAdd(this.contarctAdd).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("contract-list");
                        } else {
                            this.$msg.msgs("提交失败！" + rd.msg);
                        }
                    })
                })
            },
        },
        mounted() {
            let instid = this.$route.query.instid;
            if (this.$route.query.key != null && this.$route.query.key != '') {
                this.contractId = this.$route.query.key;
            }
            if (null == instid || instid == '') {
                this.disabled = true;
                this.fileFlag = false;
                this.lastflag = false;
                if (this.contractId != null) {
                    ss.contractService.selectByIdAgent(this.contractId).then(rd => {
                        this.guanlianxiangmFlag = false;
                        this.formInline = rd.obj;
                        if (this.formInline.lianqun != null && this.formInline.lianqun) {
                            let s = this.formInline.lianqun;
                            this.getLianquns(s)
                        }
                        if (this.formInline.saleareaCode != null && this.formInline.saleareaCode) {
                            this.getAreaCity();
                        }
                        if (this.formInline.salesCity != null && this.formInline.salesCity) {
                            console.log(this.formInline.salesCity)
                            let s = this.formInline.salesCity;
                            this.getCity(s)
                        }
                        this.selectPageAll();
                        this.queryMb()
                    })
                } else {
                    var coflag = {
                        codeflag: 6
                    }
                    ss.contractService.getContractCode(coflag).then(rd => {
                        var date = new Date();
                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        var day = date.getDate();
                        if (month < 10) {
                            month = 0 + month.toString();
                        }
                        this.formInline.id = year.toString() + month.toString() + day.toString() + "HT" + rd;
                        this.contractId = this.formInline.id;
                        console.log(year.toString() + month.toString() + day.toString());
                        console.log(this.formInline.id);
                    })
                    this.selectPageAll();
                    this.queryMb()
                }
                ;
            }


        },
        created() {
            this.instid = this.$route.query.instid;
            if (this.$route.query.isXy == 1) {
                this.isXy = true;
                console.log("this.contarctAddList", this.contarctAddList)
            } else {
                this.isXy = false;
            }
            if (this.$route.query.isFb == 1) {
                this.isFb = true;
            }
            console.log("this.isXy", this.isXy);
            let taskid = this.$route.query.taskid;
            this.selectChannel();
            this.tabIndex = '1';
            if (null != this.instid && this.instid != '') {
                this.disabled = true;
                //根据instid查询数据
                ss.contractService.getContractByInstid(this.instid).then(rd => {
                    console.log('rdrdrd', rd)
                    if (rd.f) {
                        this.formInline = rd.msg;
                        this.contractId = this.formInline.id;
                        if (this.formInline.contractAgent == '11' || this.formInline.contractAgent == '12' || this.formInline.contractAgent == '13') {
                            this.isKa = true;
                        }
                    }
                })
            }
        }
    }
</script>

<style>
    /* .h-formbLine .el-form-item__label{
        width: 18%;
    } */
    .yearIcon .el-input:after {
        content: '天';
        font-size: 0.18rem;
        color: #b8b6b6;
        /* font-weight: bold; */
        position: absolute;
        right: 0.15rem;
    }

    .weekplandetail1 .h-formbLine .el-form-item__label {
        width: 11%;
        text-align: right;
    }

    .weekplandetail23 .h-formbLine .el-form-item__label {
        width: 34%;
        text-align: right;
    }

    .weekplandetail23 .h-formbLine .el-form-item__content {
        width: 66%;
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 10.4%;
    }

    .weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 89.6%;
    }

    .ljjtips .el-table tbody td .cell {
        padding: 0.2rem 0.1rem;
    }

    .outerCon {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        margin-bottom: 30px;


    .tabBtn {
        background-color: #f0f5fb;
        padding: 10px;
        border: 1px solid #dae0f0;
        margin-right: 10px;
        color: #282c2f;
        cursor: pointer;
    }

    .tabBtnAc {
        color: white;
        background-color: #2785e7;
    }

    .foundation-box {
        font-size: 0.18rem;
        color: #868686;
        line-height: 0.28rem;
    }

    .hsalesCity {
        width: 25%;
        padding-right: 0.5rem
    }

    .signsign .h-formbLine .el-form-item__label {
        width: 39%;
    }

    .zhanghu .h-formbLine .el-form-item__content,
    .signsign .h-formbLine .el-form-item__content {
        width: 52%;
    }

    .zhanghu .h-formbLine .h-elformWrap-2,
    .signsign .h-formbLine .h-elformWrap-2 {
        width: 25%;
        padding-right: 0
    }

    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 2.6rem;
            left: 3.15rem;
            width: 4rem;
            height: 1.7rem;
        }

        .step2 {
            top: 4.55rem;
            left: 3.9rem;
            width: 13.5rem;
            height: 2.3rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
    ::v-deep .el-input__inner {
        border-radius: 0;
        border: none;
        border-bottom: 1px solid #dcdfe6;
    }
    ::v-deep .el-textarea__inner{
        border-radius: 0;
        border: none;
        border-bottom: 1px solid #dcdfe6;
    }
    ::v-deep .el-tag {
      padding: 0 0.1rem;
    }
    ::v-deep .el-upload-list__item{
        line-height: 40px;
    }
    ::v-deep .el-form-item__label{
      font-size: 12px;
    }
    ::v-deep .el-form-item{
      margin-bottom: 0;
    }
    ::v-deep .el-upload-list__item{
      font-size: 12px;
    }
</style>
